// removed by extract-text-webpack-plugin
module.exports = {"container":"no-envelopes__container___1VGTy"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-envelopes/no-envelopes.scss
// module id = 1344
// module chunks = 0